import { Environment } from './environment.type';

export const environment: Environment = {
  name: 'qa',
  backend: {
    hostname: '',
    authService: {
      production: false,
      baseApiUrl:
        'https://qa-ia.waseel.com/api/insurance-aggregator-authentication',
      baseUrl: 'https://qa-ia.waseel.com',
    },
    keycloak: {
      url: 'https://qa-iam.waseel.com/',
      realm: 'insurance-aggregator-qa',
      clientId: 'insurance-aggregator-ui',
      keycloakRedirectUri: 'https://qa-ia.waseel.com/',
    },
    employeeManagmentService: {
      production: false,
      baseApiUrl:
        'https://qa-ia.waseel.com/api/insurance-aggregator-employee-management',
      baseUrl: 'https://qa-ia.waseel.com',
    },
    senderService: {
      production: false,
      baseApiUrl: 'https://qa-ia.waseel.com/api/insurance-aggregator-sender',
      baseUrl: 'https://qa-ia.waseel.com',
    },
    searchService: {
      production: false,
      baseApiUrl: 'https://qa-ia.waseel.com/api/insurance-aggregator-search',
      baseUrl: 'https://qa-ia.waseel.com',
    },
    PaymentService: {
      production: false,
      baseApiUrl: 'https://qa-ia.waseel.com/api/insurance-aggregator-payment-integration',
      baseUrl: 'https://qa-ia.waseel.com',
    },
  },
  recaptcha: {
    siteKey: '6Ldm2hYsAAAAAOiqpM__m_g1uaZ_rYSR7I6B8051'
  },
};
